import React from "react";

function DistributorProfileModal({ war_data, isHammer, isOpp }) {
    return (
        <>
            <div
                className="modal fade distributor-player-modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content dpm-content">
                        {/* Tab Content */}
                        <div className="tab-content" id="myTabContent">
                            {isHammer === false && isOpp === false && war_data && war_data.my_kd_ip &&
                                war_data.my_kd_ip.map((tab, index) => (
                                    <div
                                        key={index}
                                        className={`tab-pane fade ${index === 0 ? "show active" : ""
                                            }`}
                                        id={`tab-${index}`}
                                        role="tabpanel"
                                        aria-labelledby={`tab-${index}-tab`}
                                    >
                                        {/* Tab Pane Content */}
                                        <div className="profile-container text-center pt-3">
                                            <div className="inner-profilecontainer">
                                            <img
                                                src={tab.profile_pic && tab.profile_pic.trim() !== "" ? tab.profile_pic : "../images/BOR/avatar.jpg"}
                                                // src="../images/BOR/avatar.jpg"
                    
                                                alt="Profile"
                                                className="img-fluid w-100"
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent infinite loop in case fallback image also fails
                                                    e.target.src = "../images/BOR/avatar.jpg"; // Set fallback image
                                                }}
                                            />
                                            </div>
                                        </div>

                                        <div className="name-header text-center mt-2">
                                            <p>{tab.shopName}</p>
                                        </div>

                                        <div className="point1-box pr-5 pl-5">
                                            <div className="astraheader">
                                                <p>Astra</p>
                                            </div>
                                            <div className="astrapoints">
                                                <p>{tab.astra} Completed</p>
                                            </div>
                                        </div>

                                        <div className="point2-box pr-5 pl-5">
                                            <div className="pointheader">
                                                <p>Points</p>
                                            </div>
                                            <div className="pointsh">
                                                <p>{Math.round(tab.points)}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            {isHammer && isOpp === false && war_data && war_data.my_kd_top && war_data.my_kd_top.map((tab, index) => (
                                <div
                                    key={index}
                                    className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                                    id={`tab-content-${index}`} // Updated ID to match the href below
                                    role="tabpanel"
                                    aria-labelledby={`tab-${index}`} // Matches the tab's id
                                >
                                    {/* Tab Pane Content */}
                                    <div className="profile-container text-center pt-3">
                                    <div className="inner-profilecontainer">
                                        <img
                                            src={tab.profile_pic && tab.profile_pic.trim() !== "" ? tab.profile_pic : "../images/BOR/avatar.jpg"}
                                            // src="../images/BOR/avatar.jpg"
                                            alt="Profile"
                                            className="img-fluid w-100"
                                            onError={(e) => {
                                                e.target.onerror = null; // Prevent infinite loop in case fallback image also fails
                                                e.target.src = "../images/BOR/avatar.jpg"; // Set fallback image
                                            }}
                                        />
                                        </div>
                                    </div>

                                    <div className="name-header text-center mt-2">
                                        <p>{tab.shopName}</p>
                                    </div>

                                    <div className="point1-box pr-5 pl-5">
                                        <div className="astraheader">
                                            <p>Astra</p>
                                        </div>
                                        <div className="astrapoints">
                                        {
                                                tab.astra > 0 &&
                                            Array(tab.astra)
                                                .fill(null)
                                                .map((_, index) => (
                                                    <img
                                                        key={index}
                                                        src="../images/BOR/brahmastra-stone1.png"
                                                        className="img-fluid astraimgstone"
                                                        alt="Astra"
                                                    />
                                                ))}
                                            <span>{tab.astra} Completed</span>
                                        </div>
                                    </div>

                                    <div className="point2-box pr-5 pl-5">
                                        <div className="pointheader">
                                            <p>Points</p>
                                        </div>
                                        <div className="pointsh">
                                            <p>{Math.round(tab.points)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}


                            {/* Opponent KD IP modal */}

                            {isHammer === false && isOpp && war_data && war_data.opp_kd_ip && war_data.opp_kd_ip.map((tab, index) => (
                                <div
                                    key={index}
                                    className={`tab-pane fade ${index === 0 ? "show active" : ""
                                        }`}
                                    id={`tab-${index}`}
                                    role="tabpanel"
                                    aria-labelledby={`tab-${index}-tab`}
                                >
                                    {/* Tab Pane Content */}
                                    <div className="profile-container text-center pt-3">
                                        <img
                                            src={tab.profile_pic}
                                            alt="Profile"
                                            className="img-fluid"
                                        />
                                    </div>

                                    <div className="name-header text-center mt-4">
                                        <p>{tab.shopName}</p>
                                    </div>

                                    <div className="point1-box pr-5 pl-5">
                                        <div className="astraheader">
                                            <p>Astra</p>
                                        </div>
                                        <div className="astrapoints">
                                        {
                                                tab.astra > 0 &&
                                            Array(tab.astra)
                                                .fill(null)
                                                .map((_, index) => (
                                                    <img
                                                        key={index}
                                                        src="../images/BOR/brahmastra-stone1.png"
                                                        className="img-fluid astraimgstone"
                                                        alt="Astra"
                                                    />
                                                ))}
                                            <p>{tab.astra} Completed</p>
                                        </div>
                                    </div>

                                    <div className="point2-box pr-5 pl-5">
                                        <div className="pointheader">
                                            <p>Points</p>
                                        </div>
                                        <div className="pointsh">
                                            <p>{Math.round(tab.points)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {isHammer && isOpp && war_data && war_data.opp_kd_top && war_data.opp_kd_top.map((tab, index) => (

                                <div
                                    key={index}
                                    className={`tab-pane fade ${index === 0 ? "show active" : ""
                                        }`}
                                    id={`tab-${index}`}
                                    role="tabpanel"
                                    aria-labelledby={`tab-${index}-tab`}
                                >
                                    {/* Tab Pane Content */}
                                    <div className="profile-container text-center pt-3">
                                        <img
                                            src={tab.profile_pic}
                                            alt="Profile"
                                            className="img-fluid"
                                        />
                                    </div>

                                    <div className="name-header text-center mt-4">
                                        <p>{tab.shopName}</p>
                                    </div>

                                    <div className="point1-box pr-5 pl-5">
                                        <div className="astraheader">
                                            <p>Astra</p>
                                        </div>
                                        <div className="astrapoints">
                                            <p>{tab.astra} Completed</p>
                                        </div>
                                    </div>

                                    <div className="point2-box pr-5 pl-5">
                                        <div className="pointheader">
                                            <p>Points</p>
                                        </div>
                                        <div className="pointsh">
                                            <p>{Math.round(tab.points)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Opponent KD IP */}
                        </div>

                        {/* Navigation Tabs */}
                        <ul className="nav nav-tabs imgprofiledist-nav mt-5" id="myTab" role="tablist">

                            {isHammer === false && isOpp === false && war_data && war_data.my_kd_ip && war_data.my_kd_ip.map((tab, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className={`nav-link imgprofile-navlink ${index === 0 ? "active" : ""}`}
                                        id={`tab-${index}-tab`}
                                        data-toggle="tab"
                                        href={`#tab-${index}`}
                                        role="tab"
                                        aria-controls={`tab-${index}`}
                                        aria-selected={index === 0}
                                    >
                                        <img
                                            src="../images/BOR/back-warriro-arrownewsolo.png"
                                            alt="Tab"
                                            className="distmodal-tabimg img-fluid"
                                        />
                                    </a>
                                </li>
                            ))}

                            {/* {isHammer && isOpp === false && war_data && war_data.my_kd_top && war_data.my_kd_top.filter(tab => tab.rank <= 5)
                            .sort((a, b) => a.rank - b.rank)
                            .map((tab, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className={`nav-link imgprofile-navlink ${index === 0 ? "active" : ""}`}
                                        id={`tab-${index}`} // Tab's unique ID
                                        data-toggle="tab"
                                        href={`#tab-content-${index}`} // Matches the content's ID
                                        role="tab"
                                        aria-controls={`tab-content-${index}`} // Matches the content's ID
                                        aria-selected={index === 0}
                                    >
                                        <img
                                            src="../images/BOR/back-view-warriro-hammernewsolo.png"
                                            alt="Tab"
                                            className="distmodal-tabimg-hammer img-fluid"
                                        />
                                    </a>
                                </li>
                            ))} */}
                            {isHammer && isOpp === false && war_data && war_data.my_kd_top && 
                                [...war_data.my_kd_top]
                                    .filter(tab => tab.rank <= 5)
                                    .sort((a, b) => a.rank - b.rank)
                                    .map((tab, index) => (
                                        <li key={tab.rank} className="nav-item">  {/* use tab.rank as key */}
                                            <a
                                                className={`nav-link imgprofile-navlink ${index === 0 ? "active" : ""}`}
                                                id={`tab-${index}`}
                                                data-toggle="tab"
                                                href={`#tab-content-${index}`}
                                                role="tab"
                                                aria-controls={`tab-content-${index}`}
                                                aria-selected={index === 0}
                                            >
                                                <img
                                                    src="../images/BOR/back-view-warriro-hammernewsolo.png"
                                                    alt="Tab"
                                                    className="distmodal-tabimg-hammer img-fluid"
                                                />
                                            </a>
                                        </li>
                                    ))
                            }

                            {/*OPPonent KD IP */}

                            {isHammer === false && isOpp && war_data && war_data.opp_kd_ip && war_data.opp_kd_ip.map((tab, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className={`nav-link imgprofile-navlink ${index === 0 ? "active" : ""}`}
                                        id={`tab-${index}-tab`}
                                        data-toggle="tab"
                                        href={`#tab-${index}`}
                                        role="tab"
                                        aria-controls={`tab-${index}`}
                                        aria-selected={index === 0}
                                    >
                                        <img
                                            src="../images/BOR/back-warriro-arrownew.png"
                                            alt="Tab"
                                            className="distmodal-tabimg img-fluid"
                                        />
                                    </a>
                                </li>
                            ))}

                            {isHammer && isOpp && war_data && war_data.opp_kd_top && war_data.opp_kd_top.map((tab, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className={`nav-link imgprofile-navlink ${index === 0 ? "active" : ""}`}
                                        id={`tab-${index}-tab`}
                                        data-toggle="tab"
                                        href={`#tab-${index}`}
                                        role="tab"
                                        aria-controls={`tab-${index}`}
                                        aria-selected={index === 0}
                                    >
                                        <img
                                            src="../images/BOR/back-view-warriro-hammernewsolo.png"
                                            alt="Tab"
                                            className="distmodal-tabimg-hammer img-fluid"
                                        />
                                    </a>
                                </li>
                            ))}

                            {/*Opponent KD IP */}
                        </ul>

                        {/* Modal Close Button */}
                        <div className="footerclose-contaner mb-1">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">
                                    <img
                                        src="../images/BOR/close-button.png"
                                        alt="Close"
                                        className="img-fluid w-50"
                                    />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default DistributorProfileModal;
